<template>
    <div v-if="loading || nativeLoading" v-loading="true" :style="`height: ${loadingHeigth}px`"></div>
    <div :style="`position: relative; height: ${loadingHeigth}px`" v-else-if="nativeError || error">
        <ExceptionWithReload @reload="doFetchData" :visible="true"></ExceptionWithReload>
    </div>
    <el-empty v-else-if="noData"></el-empty>
    <slot v-else></slot>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue';
import ExceptionWithReload from './Exceptions/ExceptionWithReload.vue';
const nativeLoading = ref(false);
const nativeError = ref(false);
const props = defineProps({
    loadingHeigth: {
        type: Number,
        default: 200
    },
    loading: {
        type: Boolean,
        default: false
    },
    error: {
        type: Boolean,
        default: false
    },
    noData: {
        type: Boolean,
        default: false
    },
    loadData: {
        type: Function,
        default: () => Promise.resolve()
    },
    reMountedSeed: {
        type: Number,
        default: 0
    }
});

function doFetchData() {
    nativeLoading.value = true;
    nativeError.value = false;
    props.loadData().catch(e => {
        console.error(e);
        nativeError.value = true;
    }).finally(() => {
        nativeLoading.value = false;
    });
}

onMounted(() => {
    doFetchData();
});

watch(() => props.reMountedSeed, () => {
    nativeLoading.value = true;
    // 强制重渲染报告所有组件
    setTimeout(() => {
        nativeLoading.value = false;
    });
});
</script>
